import { createBrowserHistory } from 'history'
import { createReduxHistoryContext } from 'redux-first-history'
import auditTrailService from '../services/audit-trail'

const { createReduxHistory, routerMiddleware, routerReducer } = createReduxHistoryContext({
  history: createBrowserHistory(),
});

const getConnectedHistory = (store) => {
  const history = createReduxHistory(store)

  history.listen(({ location, action }) => {
    if (location && location.pathname.startsWith('/admin')) {
      auditTrailService.trackPageView(location.pathname)
    }
  });

  return history
};

export { routerMiddleware, routerReducer }
export default getConnectedHistory
